import { Logomark } from '@carespace-icons/Logo/logomark';
import { LogomarkBlue } from '@carespace-icons/Logo/logomarkBlue';
import { useEffect, useState } from 'react';

interface LogoWithFallbackProps {
  download?: boolean;
}

const LogoWithFallback = ({ download }: LogoWithFallbackProps) => {
  const [imgError, setImgError] = useState(false);
  const [logo, setLogo] = useState<string>('');

  useEffect(() => {
      const host = window.location.hostname;
      const parts = host.split('.');
      const logoPart = parts.slice(0, -2).join('.')
      const logoUrl = `https://risecxlibrary.blob.core.windows.net/documents/${logoPart}_logo_small.png`;
      setLogo(logoUrl);
    },[])

  if (!logo) return null;

  return imgError ? (
    download ? (
      <LogomarkBlue />
    ) : (
      <Logomark />
    )
  ) : (
    <img
      key={logo}
      src={logo}
      alt="logo"
      onError={() => setImgError(true)}
      style={{ width: `${download ? 'auto' : '45px'}`, borderRadius: '10px', background:'#fff' }}
    />
  );
};


export default LogoWithFallback;